import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowBigUpDash: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M9 19h6' }],
    ['path', { d: 'M9 15v-3H5l7-7 7 7h-4v3H9z' }],
  ],
];

export default ArrowBigUpDash;
